import { KVRow, SectionCard } from '@components';
import React from 'react';
import { Cpu } from 'react-feather';
import DateFormatted from '../../components/typography/Date';
import Time from '../../components/typography/Time';
import { Capitalize } from '../../utils/text/Capitalize';

interface ComputerInfo {
  category: string;
  deviceInfo: [];
}

export const RmmDeviceInfo = ({ deviceInfo, category }: ComputerInfo) => {
  const allowedCategories = [
    'Desktop',
    'Laptops',
    'Laptop',
    'Computers',
    'Werkstation',
  ];

  if (!allowedCategories.includes(Capitalize(category))) return;

  return (
    <>
      <SectionCard title="Algemeen">
        <KVRow label="Computernaam" value={deviceInfo.systemName ?? '/'} />
        <KVRow
          label="Serienummer"
          value={deviceInfo.system?.serialNumber ?? '/'}
        />

        <KVRow
          label="Laatste keer opgestart"
          value={
            <>
              <DateFormatted date={deviceInfo.lastContact * 1000} />{' '}
              <Time time={deviceInfo.lastContact * 1000} />
            </>
          }
        />

        <KVRow
          label="Laatste gebruiker"
          value={deviceInfo.lastLoggedInUser ?? '/'}
        />

        <KVRow
          label="Huidige status"
          value={
            <span
              className={deviceInfo.offline ? 'text-red-500' : 'text-green-500'}
            >
              {deviceInfo.offline ? 'Uitgeschakeld' : 'Ingeschakeld'}
            </span>
          }
        />

        <KVRow label="Besturingssysteem" value={deviceInfo.os?.name ?? '/'} />

        <KVRow
          label="Werkgeheugen"
          value={
            deviceInfo.memory?.capacity
              ? `${Math.floor(deviceInfo.memory.capacity / 1024000000)} GB`
              : '/'
          }
        />
      </SectionCard>

      <SectionCard title="Processor" icon={<Cpu size={13} />}>
        {deviceInfo.processors?.map((processor: any, index: number) => (
          <div key={index} className="space-y-1">
            <KVRow label="Naam" value={processor?.name} />
            <KVRow label="Cores" value={processor?.numCores} />
            <KVRow label="Logische kernen" value={processor?.numLogicalCores} />
            <KVRow
              label="Kloksnelheid"
              value={
                processor?.clockSpeed
                  ? `${
                      Math.round((processor.clockSpeed / 1000000000) * 100) /
                      100
                    } GHz`
                  : '/'
              }
            />
          </div>
        ))}
      </SectionCard>
    </>
  );
};

export default RmmDeviceInfo;
